<template>
    <div>
        <md-dialog :md-fullscreen="false"
                   :md-active.sync="showDialog"
                   :md-click-outside-to-close="false">
            <md-dialog-title>Share</md-dialog-title>
            <md-dialog-content>
                <social-sharing :url="`https://flapp-match.credovita.io/requests/${loanId}`"
                                :title="`Help ${borr} with their borrowing request!`"
                                :description="headline"
                                :quote="headline"
                                inline-template
                >
                    <md-list>
                        <network network="facebook">
                            <md-list-item href="#">
                                Facebook
                            </md-list-item>
                        </network>
                        <network network="twitter">
                            <md-list-item href="#">
                                Twitter
                            </md-list-item>
                        </network>
                        <network network="viber">
                            <md-list-item href="#">
                                Viber
                            </md-list-item>
                        </network>
                        <network network="whatsapp">
                            <md-list-item href="#">
                                Whatsapp
                            </md-list-item>
                        </network>
                        <network network="sms">
                            <md-list-item href="#">
                                SMS
                            </md-list-item>
                        </network>
                        <network network="email">
                            <md-list-item href="#">
                                Email
                            </md-list-item>
                        </network>
                    </md-list>
                </social-sharing>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="$emit('update:showDialog', false)">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    export default {
        name: "social-share",
        props: ['card', 'showDialog', 'loanId', 'borr', 'headline']
    }
</script>

<style scoped>

</style>